import React, { useState, useEffect } from "react";
import { Box } from '@mui/joy';
import { Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import MaturatoAnalisiKPISet from "../maturatoAnalisi/MaturatoAnalisi.KPISet";

const MaturatoTimeline = ({ dataProviderName, filters: defaultFilters, $key }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState(false);
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        const shaped = { items: [...(filterModel.items || []), { field: "status", operator: "equals", value: "accepted" }] };
        setLocalFilterModel(shaped);
        setLocalDrawable(true);
    }, [filterModel]);

    const showKPI = true;
    const showMaturatoTimeline = true;

    const createTimelineBarFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Maturato')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <MaturatoAnalisiKPISet dataProviderName={dataProviderName} filters={filterModel} />
                </Box>
            }

            {showMaturatoTimeline && localDrawable &&
                <Box className="report-itemgroup report-itemgroup-timeline" sx={{ marginTop: '10px', marginBottom: '30px' }}>
                    <Box className="report-item">
                        <Bar
                            title={t("Maturato per mese")}
                            dataProviderName="statisticsviews/maturatocommissionbymonth/timelinedfinancial/views_opportunities_proposal/registered_at/month/totalCommissionValue/_related_area_name"
                            filters={localFilterModel}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', addFilter)}
                            showTooltip={true}
                            format="currency"
                        />
                        <Bar
                            title={t("Maturato per settimana")}
                            dataProviderName="statisticsviews/maturatocommissionbyweek/timelinedfinancial/views_opportunities_proposal/registered_at/week/totalCommissionValue"
                            filters={localFilterModel}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', addFilter)}
                            height={200}
                            format="currency"
                        />
                    </Box>
                </Box>
            }
        </Box>
    );
};

export default MaturatoTimeline;
